import { render, staticRenderFns } from "./DriverNew.vue?vue&type=template&id=5d2622b0&scoped=true&"
import script from "./DriverNew.vue?vue&type=script&lang=js&"
export * from "./DriverNew.vue?vue&type=script&lang=js&"
import style0 from "./DriverNew.vue?vue&type=style&index=0&id=5d2622b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2622b0",
  null
  
)

export default component.exports